var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"stars"},[_c('van-rate',{attrs:{"size":15,"allow-half":"","color":"#ffd21e","void-icon":"star","void-color":"#eee"},model:{value:(_vm.star),callback:function ($$v) {_vm.star=$$v},expression:"star"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }